import { gql } from "@apollo/client";
import { HOME_AWAY_TEAM_COLORS } from "helpers/colors";
import React from "react";

import PlayerAvatar from "../atoms/PlayerAvatar";

export const GamePlayerAvatarFragment = gql`
  fragment GamePlayerAvatarFragment on GamePlayer {
    id
    playerNumber
    isHomeTeamPlayer
  }
`;

export default function GamePlayerAvatar({ gamePlayer, ...others }) {
  const teamColor = HOME_AWAY_TEAM_COLORS[gamePlayer?.isHomeTeamPlayer ? "home" : "away"];

  return <PlayerAvatar color={teamColor} playerNumber={gamePlayer?.playerNumber} {...others} />;
}
